import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinObject',
  standalone: true,
})
export class JoinObjectPipe implements PipeTransform {
  transform(array: object[]): object {
    return array.reduce((prev, curr) => ({ ...prev, ...curr }), {});
  }
}
